import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 7a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-4a4 4 0 0 1 -4 -4l0 -10","key":"svg-0"}],["path",{"d":"M12 7l0 4","key":"svg-1"}]]

const IconMouse = createReactComponent('outline', 'mouse', 'Mouse', __iconNode);

export default IconMouse;